import React from 'react';
import { useShowDemoData } from '@bbkAdminComponents/play/use-show-demo-data';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';
import { useGetProductLicense } from '@bbkAdminUtils/plans';

export const DemoDataBanner: React.FC<
  React.PropsWithChildren<{ className?: Argument; isDemoData?: boolean }>
> = ({ className, children, isDemoData: isDemoDataProp }) => {
  const isDemoDataEnabled = useShowDemoData();
  const isDemoData = isDemoDataProp ?? isDemoDataEnabled;
  const productLicense = useGetProductLicense();
  const growthV2License = productLicense?.growthV2License;

  return isDemoData ? (
    <div
      className={cs('-tw-mt-4 tw-mb-2 tw-flex tw-justify-center', className)}
    >
      <div
        className={cs(
          'tw-px-2 tw-py-0.5',
          'tw-border tw-border-cbrwarn-600',
          'tw-text-center tw-text-sm tw-text-cbrwarn-600',
          'tw-rounded tw-bg-cbrwarn-50'
        )}
      >
        {children ?? (
          <>
            {growthV2License
              ? 'Sample data shown here. Launch a play to view real data.'
              : 'Sample data shown here. Launch a live cancel page to view real data.'}
          </>
        )}
      </div>
    </div>
  ) : undefined;
};
